
import React from 'react';
import Footer from '../components/Footer';


const CompApropos = () => {
    return (
        <div>

            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>

            <div className="container">
                <div className="row">
                    <div className="row text-center">
                        <div className="col-lg-6 offset-lg-3">
                            <div className="about_header mb-5">
                                <span className="top-title">Votre réflexologue</span>


                                <p>Membre de la Fédération Francaise des Réflexologues</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="about_content">

                            <div className="about_content-thumb">
                                <div className="about_content-thumb-image">
                                    <img className="imgpage" src="assets/img/nive_photo.jpg" alt="about-img" />
                                </div>
                            </div>
                            <div className="about_content-inner">
                                <div className="about_content-inner-blob">

                                </div>
                                <div className="mb-4 text-light">
                                    <h3 id="i-design-and-build-ultimate-things">Ma formation en Réflexologie</h3>
                                    <p>Practicienne en Chi Nei Tsang  (Shinzen School & Temana) 2023

                                    </p>
                                    <p>Practicienne en Shiroshampi (Ecole Internationale du Spa) 2023

                                    </p>
                                    <p>
                                        Formation dispensée par l'Académie Francilienne de Réflexologie

                                        <br></br>
                                        Certification Professionnelle de Réflexologue 2021
                                    </p>
                                    <p>THE MIKKI SCHOOL-Techniques de massage 2020</p>
                                </div>
                                <div><a className="btn btn-primary mr-3 btn-zoom" href="/contact">Me contacter</a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br></br>
            <br></br>
            <div className="container">

                <div className="about_header mb-5">
                    <span className="top-title">Son parcours et ses motivations</span>


                    <p>Quel chemin pour venir à la réflexologie…</p>
                    <p>Après 20 ans dans le métier du voyage, à aider à la réalisation de voyages exceptionnels pour des grands passionnés du sous-continent Indien et de l’Orient, elle a enfin sauté le pas : aller au bout d’un rêve qu’elle nourrissait depuis quelques années. Celui d’aider, de soutenir et de soulager ceux qui en ont besoin par ses mains !</p>
                    <p>De nature bienveillante et attentionnée et en raison de son origine, elle a toujours été attirée par les médecines douces : à travers les massages, l’homéopathie, les huiles essentielles…</p>
                    <p>Formée de manière très holistique au sein de l’Académie Francilienne de Réflexologie, l’approche de Nive repose sur une écoute attentive de la personne, dans le respect de ses besoins.</p>
                    <p>C’est un réel moment de prise en compte de soi pour les personnes qui mettront leurs pieds dans les mains de Nive.</p>
                    <p>Aujourd'hui, j'interviens dans les structures telles que Maison Sport Santé, Centre Sport Santé ou des Associations Socio-Culturelles</p>
                    <p>Je donne aussi de mon temps  au Personnel Soignant à La Maison des Usagers de l'Hôpital Delafontaine de Saint Denis</p>
                    <p>Je propose des animations sous forme d'Ateliers Collectifs de Découverte de la Réflexologie - Me contacter pour plus d'informations</p>
                </div>
            </div>

            <br></br>


            <div className="container">
                <div className="elfsight-app-3f631622-f6e4-43a2-b394-0908f24adc0c" data-elfsight-app-lazy></div>
            </div>

            <br></br>

            <Footer />
        </div>


    )

}

export default CompApropos;